// ABOUTME: Confirmation modal for disabling MFA.
// ABOUTME: Requires current TOTP code entry before allowing disable.
import { Box, useTheme } from "@mui/material";
import OtpInput from "../../theme/inputs/OtpInput";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import SHModal from "../../theme/Modal/SHModal";
import Subheading from "../../theme/text/Subheading";
import Text from "../../theme/text/Text";
import Shbutton from "../../theme/buttons/Shbutton";
import ButtonGroup from "../../theme/buttons/ButtonGroup";
import { tokens } from "../../../theme";
import { useDisableMfaMutation } from "../../../newapi/user/mfaSlice";
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import { showToastMessage } from "../../../utils/toasts";

const MConfirmDisableMfa = (props) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const { t } = useTranslation();

    const [code, setCode] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [disableMfa, { isLoading }] = useDisableMfaMutation();

    let isStandAlone = false;
    if (window.matchMedia('(display-mode: standalone)').matches) {
        isStandAlone = true;
    }

    const handleConfirm = async (codeOverride) => {
        setErrorMessage("");
        try {
            const result = await disableMfa({ code: codeOverride || code }).unwrap();
            if (result.success) {
                showToastMessage("success", t("mfa_disabled_successfully"));
                setCode("");
                props.handleClose();
            } else {
                setErrorMessage(result.error || t("invalid_code_try_again"));
            }
        } catch (err) {
            setErrorMessage(err?.data?.error || t("invalid_code_try_again"));
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter" && code.length === 6) {
            handleConfirm();
        }
    };

    const handleClose = () => {
        setCode("");
        setErrorMessage("");
        props.handleClose();
    };

    return (
        <SHModal
            open={props.open}
            onClose={handleClose}
            onKeyDown={handleKeyDown}
        >
            <Box 
                sx={{ 
                    textAlign: "center", 
                    py: 4, 
                    px: 5, 
                    display: "flex", 
                    flexDirection: "column", 
                    maxWidth: 500 
                }}
            >
                <Subheading>{t("confirm_disable_mfa")}</Subheading>
                <Text center light>{t("confirm_disable_mfa_subtitle")}</Text>
            </Box>
            <Box sx={{
                background: theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0],
                p: 3,
                borderTopLeftRadius: 16,
                borderTopRightRadius: 16,
                textAlign: "center",
            }}>
                <OtpInput
                    value={code}
                    onChange={(val) => { setCode(val); setErrorMessage(""); }}
                    onComplete={(val) => handleConfirm(val)}
                    error={!!errorMessage}
                    autoFocus
                />
                {errorMessage && (
                    <Text sx={{ color: colors.red[400], mt: 1 }}>{errorMessage}</Text>
                )}
            </Box>
            <Box
                component="footer"
                sx={{
                    display: "flex",
                    width: 1,
                    paddingBottom: isStandAlone ? "32px" : "16px",
                    alignItems: "center",
                    paddingRight: 3,
                    paddingLeft: 3,
                    zIndex: 1058,
                    position: "relative",
                    background: `${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                    borderBottomLeftRadius: 24,
                    borderBottomRightRadius: 24,
                    justifyContent: "space-between",
                    "@media screen and (max-width: 47.9375em)": {
                        paddingRight: 0,
                        paddingLeft: 0,
                    }
                }}
            >
                <Shbutton
                    isCancel={true}
                    className="always-visible"
                    onClick={handleClose}
                    color="primary"
                    variant="text"
                    startIcon={<ArrowRightAltIcon />}
                >
                    {t("cancel")}
                </Shbutton>
                <ButtonGroup version={2}>
                    <Shbutton
                        className="group-btn"
                        color="red"
                        onClick={handleConfirm}
                        variant="contained"
                        disabled={code.length !== 6}
                        isLoading={isLoading}
                    >
                        {t("disable")}
                    </Shbutton>
                </ButtonGroup>
            </Box>
        </SHModal>
    );
};

export default MConfirmDisableMfa;
